import { GuestlistActionTypes } from '@bridebook/web/lib/guestlist/action-types';
import { toggleBulkAddGuestsMethodAnalytics } from '@bridebook/web/lib/guestlist/analytics/actions';
import {
  AddGuestsFlowView,
  CategoryDetailsPopupState,
  IGuestlistCategory,
} from '@bridebook/web/lib/guestlist/types';
import { IDeps } from '@bridebook/web/lib/types';
import { GuestlistAnalyticsActionTypes } from '@bridebook/web/lib/guestlist/analytics/action-types';

export const toggleCategoryDetailsPopup =
  (isVisible: boolean = false, category: IGuestlistCategory | null = null) =>
  ({ dispatch }: IDeps) => {
    if (isVisible) {
      dispatch({
        type: GuestlistAnalyticsActionTypes.CLICKED_TO_EDIT_GUEST_CATEGORY,
        payload: { category },
      });
    }

    const payload: CategoryDetailsPopupState = {
      isVisible,
      category: isVisible ? category : null,
    };
    return {
      type: GuestlistActionTypes.TOGGLE_CATEGORY_DETAILS_POPUP,
      payload,
    };
  };

export const toggleAddGuestsPopup =
  (isVisible: boolean = false) =>
  () => ({
    type: GuestlistActionTypes.TOGGLE_ADD_GUESTS_POPUP,
    payload: isVisible,
  });

export const setAddGuestsFlowView = (view: AddGuestsFlowView) => ({
  type: GuestlistActionTypes.SET_ADD_GUESTS_FLOW_VIEW,
  payload: view,
});

export const openAddGuestsFlow = (view: AddGuestsFlowView = 'options') => ({
  type: GuestlistActionTypes.OPEN_ADD_GUESTS_FLOW,
  payload: view,
});

/**
 * Navigates from the contacts import modal back to the add-guests options view.
 * Single dispatch handles all state changes; analytics fired separately.
 */
export const returnFromContactsToAddGuests =
  () =>
  ({ dispatch }: IDeps) => {
    dispatch(toggleBulkAddGuestsMethodAnalytics('bulkAddGuestPopup'));

    return {
      type: GuestlistActionTypes.RETURN_FROM_CONTACTS_TO_ADD_GUESTS,
    };
  };

/**
 * Navigates from the add-guests popup to the contacts import view.
 * Single dispatch handles all state changes; analytics fired separately.
 */
export const openContactsFromAddGuests =
  () =>
  ({ dispatch }: IDeps) => {
    dispatch(toggleBulkAddGuestsMethodAnalytics('importContacts'));

    return {
      type: GuestlistActionTypes.OPEN_CONTACTS_FROM_ADD_GUESTS,
    };
  };
